var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeRmeq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1912,
    viewBox: "0 0 2000 1912",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter0_f_11251_2601)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1292.04,
    cy: 754.484,
    rx: 607.964,
    ry: 622.031,
    fill: "#47B3FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter1_f_11251_2601)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.964,
    cy: 722.031,
    rx: 607.964,
    ry: 622.031,
    fill: "#D295FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.187 1674.77C312.388 1682.12 320.295 1648.5 329.124 1614.02C337.953 1579.54 325.938 1539.11 325.938 1539.11L333.615 1582.98C333.615 1582.98 296.727 1556.98 252.507 1448.84C224.877 1379.48 204.871 1307.22 192.855 1233.38L195.811 1252.93C195.811 1252.93 124.759 1229.47 139.077 1186.47C145.718 1166.41 201.3 1155.19 234.12 1165.12C250.587 1170.05 303.905 1108.31 536.406 1048.18C768.907 988.056 853.356 983.09 853.356 983.09L830.823 1003.81C830.823 1003.81 903.948 943.799 917.383 933.439C930.818 923.078 983.444 916.627 981.947 970.032C980.425 1003.58 970.501 1036.18 953.119 1064.72L968.474 1034.11C968.474 1034.11 1004.86 1093.61 1019.53 1227.63C1034.19 1361.66 1057.91 1448.72 1057.91 1448.72L1059.6 1450.56C1059.6 1450.56 1118.91 1455.84 1104.63 1499.04C1097.99 1519.09 1042.4 1530.31 1009.58 1520.38C541.243 1722.51 360.024 1667.46 336.187 1674.77Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.476 1041.42C204.673 1029.26 233.769 1011.47 264.094 993.725C294.418 975.976 314.379 938.991 314.379 938.991L288.929 975.194C288.929 975.194 281.252 930.156 326.125 822.29C355.388 753.626 392.027 688.474 435.37 628.023L423.662 643.935C423.662 643.935 390.305 575.869 430.61 556.008C449.304 546.782 495.865 579.466 512.103 610.156C520.202 625.599 600.773 621.103 805.752 748.008C1010.73 874.913 1073.34 932.853 1073.34 932.853L1043.01 930.977C1043.01 930.977 1136.33 942.119 1152.91 944.621C1169.49 947.123 1210.95 980.863 1172.49 1017.18C1147.9 1039.57 1118.11 1055.18 1085.93 1062.53L1118.1 1052.17C1118.1 1052.17 1101.9 1120.32 1018.29 1224.82C934.689 1329.32 890.315 1407.67 890.315 1407.67V1410.17C890.315 1410.17 928.164 1457.09 887.859 1476.87C869.165 1486.1 822.603 1453.41 806.366 1422.72C336.642 1223.92 248.317 1053.62 226.476 1041.42Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1767.51 1543.1C1771.16 1566.56 1741.99 1555.18 1712.2 1542.67C1682.41 1530.16 1644.68 1536.84 1644.68 1536.84L1684.91 1534.85C1684.91 1534.85 1657.08 1567.07 1554.7 1596.54C1489.26 1614.72 1422 1625.28 1354.22 1628.02L1372.22 1627.51C1372.22 1627.51 1342.47 1692.68 1305.5 1673.87C1288.35 1665.16 1285.28 1610.7 1298.13 1580.47C1304.58 1565.31 1255.91 1507.01 1230.65 1277.52C1205.39 1048.03 1211.46 966.709 1211.46 966.709L1227.27 990.714C1227.27 990.714 1182.52 913.656 1174.92 899.621C1167.32 885.585 1168.01 834.448 1215.68 842.189C1245.64 847.682 1273.67 861.066 1296.98 881.011L1271.42 862.792C1271.42 862.792 1329.23 835.034 1451.14 836.872C1573.05 838.709 1654.01 826.238 1654.01 826.238L1655.85 824.83C1655.85 824.83 1667.9 768.728 1704.87 787.533C1722.03 796.251 1725.1 850.712 1712.24 880.933C1835.61 1352.62 1763.9 1519.45 1767.51 1543.1Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M658.168 889.181C634.062 882.925 657.861 858.334 682.927 833.43C707.993 808.526 718.165 767.593 718.165 767.593L702.388 809.112C702.388 809.112 683.963 767.475 700.891 651.595C712.381 577.669 731.872 505.265 759.007 435.708L751.56 454.083C751.56 454.083 702.542 396.69 736.705 367.173C752.558 353.489 805.799 373.233 828.83 398.88C840.346 411.742 917.386 386.916 1147.01 457.523C1376.63 528.131 1451.44 568.399 1451.44 568.399L1421.62 574.303C1421.62 574.303 1514.7 561.323 1531.4 559.564C1548.1 557.804 1596.66 579.893 1568.17 624.854C1549.86 652.796 1524.83 675.501 1495.47 690.808L1524.07 672.59C1524.07 672.59 1525.11 742.689 1469.75 865.176C1414.4 987.663 1390.68 1074.77 1390.68 1074.77L1391.22 1077.23C1391.22 1077.23 1439.35 1112.93 1405.19 1142.44C1389.34 1156.13 1336.1 1136.38 1313.06 1110.74C809.599 1037.82 682.274 895.397 658.168 889.181Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.23 1055.1C1070.89 1049.83 1081.56 1082.47 1093.15 1116.25C1104.75 1150.03 1096.15 1191.16 1096.15 1191.16L1099.99 1146.82C1099.99 1146.82 1065.44 1175.87 1030.16 1287.57C1008.32 1359.04 994.313 1432.75 988.4 1507.36L989.743 1487.5C989.743 1487.5 920.841 1516.86 938.652 1558.74C946.905 1578.28 1003.22 1584.46 1035.11 1571.91C1051.12 1565.62 1109.31 1622.74 1346.04 1662.69C1582.76 1702.65 1667.21 1700.58 1667.21 1700.58L1643.03 1681.85C1643.03 1681.85 1720.83 1735.45 1735.15 1744.4C1749.47 1753.36 1802.37 1755.54 1796.57 1702.45C1792.3 1669.14 1779.73 1637.5 1760.06 1610.54L1777.8 1639.74C1777.8 1639.74 1809.2 1577.19 1812.81 1442.54C1816.41 1307.9 1833.04 1218.95 1833.04 1218.95L1834.57 1217C1834.57 1217 1893.26 1206.72 1875.45 1164.85C1867.2 1145.3 1810.89 1139.12 1778.99 1151.67C1295.64 990.087 1119.56 1060.38 1095.23 1055.1Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M637.398 1846.99C612.524 1846.99 629.721 1817.2 647.647 1786.7C665.573 1756.21 665.573 1713.98 665.573 1713.98L660.506 1758.2C660.506 1758.2 632.446 1722.58 620.316 1606.08C613.265 1531.58 614.334 1456.51 623.502 1382.25L620.815 1401.8C620.815 1401.8 559.399 1358.8 585.078 1321.46C597.055 1304.18 653.443 1309.73 682.117 1328.62C696.55 1338.12 764.915 1294.45 1004.56 1304.38C1244.2 1314.31 1326.53 1334.09 1326.53 1334.09L1299.13 1347.42C1299.13 1347.42 1386.03 1311.14 1401.77 1305.16C1417.51 1299.18 1469.79 1308.25 1453.44 1358.99C1442.58 1390.71 1423.93 1419.06 1399.27 1441.37L1422.31 1416.46C1422.31 1416.46 1440.54 1484.06 1417.05 1616.75C1393.55 1749.44 1392.02 1839.83 1392.02 1839.83L1393.13 1842.06C1393.13 1842.06 1448.52 1864.35 1422.69 1901.6C1410.71 1918.88 1354.32 1913.33 1325.65 1894.45C820.651 1952.31 662.31 1846.87 637.398 1846.99Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.56 1023.87H892.118V1362.71H1214.56V1023.87Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M997.034 1511.28H377.76V1897.03H997.034V1511.28Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1698.22 1625.94H1293.9V1844.88H1698.22V1625.94Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M604.919 510.216C604.919 510.216 554.45 495.175 563.68 464.454C567.963 450.203 606.876 441.291 630.134 447.533C641.838 450.654 678.129 406.17 840.573 359.168C1003.02 312.165 1062.35 306.901 1062.35 306.901",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.87 321.942C1046.87 321.942 1097.34 278.361 1106.42 270.84C1115.5 263.32 1152.57 257.679 1152.57 295.282C1152.15 318.93 1145.79 342.075 1134.11 362.514",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.27 340.745C1144.27 340.745 1171.18 381.769 1183.96 475.774C1196.73 569.78 1179.34 631.823 1179.34 631.823",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M785.238 782.232C774.162 778.472 740.935 789.752 724.321 795.393C707.708 801.033 700.324 785.992 705.862 761.551C711.4 737.109 702.17 708.907 702.17 708.907",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M602.625 496.456C612.511 548.173 627.988 598.616 648.774 646.864C682.001 722.069 708.472 739.629 708.472 739.629",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M689.246 515.254C709.552 541.575 772.314 558.496 772.314 558.496",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M761.385 816.071C761.385 816.071 794.612 785.99 809.38 718.306C824.147 650.622 829.057 633.062 829.057 633.062",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M831.526 552.859L827.834 543.458C827.834 543.458 781.316 541.503 793.388 507.097C805.683 472.014 845.703 508.977 845.703 508.977C845.703 508.977 851.868 502.096 901.709 494.575C951.55 487.055 982.931 507.736 982.931 507.736L963.844 498.336C963.844 498.336 974.919 461.373 1004.45 474.533C1033.99 487.694 999.544 520.897 999.544 520.897L1003.24 535.938",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.13 616.781C1016.13 616.781 1036.43 665.664 1047.51 684.465C1053.94 694.505 1062.16 703.239 1071.73 710.223",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M818.458 622.42C834.228 633.017 853.387 637.055 871.991 633.701C903.372 628.06 907.064 596.099 925.523 596.099C943.983 596.099 951.367 622.42 973.518 626.18C995.67 629.941 1029.52 612.38 1029.52 601.1C1029.52 589.819 1021.51 549.096 1015.97 541.575C1010.44 534.055 980.976 551.277 960.596 556.616C917.512 567.897 875.055 561.617 862.133 559.737C849.212 557.857 824.144 545.336 816.76 577.298C809.376 609.259 818.458 622.42 818.458 622.42Z",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M910.132 643.104C923.054 649.985 935.348 650.624 947.679 643.743",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M528.789 966.479C528.789 966.479 582.322 975.879 634.009 1045.44C685.695 1115.01 787.223 1145.09 862.907 1075.53C938.591 1005.96 933.053 949.558 855.523 876.233C777.993 802.909 652.468 789.748 567.554 868.713C482.641 947.678 493.716 987.16 493.716 987.16",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M482.496 1086.81C482.496 1086.81 491.726 1156.37 536.029 1212.78C573.28 1260.23 606.655 1266.44 616.291 1267.19",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M700.318 1536.15C694.795 1487.86 685.537 1440.08 672.629 1393.26C643.094 1287.34 597.572 1240.34 512.659 1125.65C433.283 1018.45 427.117 1007.84 427.117 1007.84C427.117 1007.84 453.182 999.832 493.571 986.784C508.339 982.047 524.694 976.632 542.526 970.691",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M836.545 860.293C859.545 850.19 881.868 838.559 903.369 825.473C1012.28 755.909 1200.57 616.781 1200.57 616.781C1200.57 616.781 1237.49 618.661 1237.49 703.266C1237.49 787.871 1261.48 930.76 1274.41 977.762C1287.33 1024.77 1335.32 1052.97 1335.32 1052.97",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.01 1210.26C1342.08 1208.38 1363.61 1196.46 1372.84 1155.1C1382.06 1113.73 1355.59 1049.81 1314.98 1047.93C1274.37 1046.05 1191.3 1105.57 1191.3 1105.57",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M716.568 1106.66C684.928 1124.94 665.25 1133.81 665.25 1133.81",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M913.675 959.602C1048.5 833.333 1145.34 690.107 1145.34 690.107",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M713.395 1357.54C718.933 1406.42 702.319 1564.35 682.014 1618.88C669.638 1652.69 662.176 1688.16 659.862 1724.16C672.784 1731.68 781.695 1773.05 947.831 1617C1113.97 1460.95 1288.7 1213.41 1334.85 1183.93",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 1588.8C1119.75 1588.96 1120.02 1589.09 1120.31 1589.18C1123 1590.27 1133.67 1593.61 1171.18 1598.2C1199.46 1600.98 1227.98 1599.72 1255.91 1594.44C1258.77 1593.93 1261.46 1592.68 1263.71 1590.81C1265.96 1588.94 1267.7 1586.51 1268.76 1583.76C1270.86 1578.27 1273.85 1570.49 1277.44 1561.2C1286.85 1537.51 1336.69 1433.35 1339.09 1358.98C1342.97 1309.19 1334.84 1232.41 1328.24 1193.53",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.03 1539.73C1055.87 1544.96 1087.47 1543.1 1117.51 1534.27C1182.12 1515.47 1254.11 1457.19 1254.11 1457.19",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1427.62 1289.86C1432.6 1305.66 1435.09 1322.15 1435.01 1338.74C1435.01 1366.94 1433.16 1415.83 1403.63 1425.23C1374.09 1434.63 1366.71 1413.95 1359.32 1400.79C1355.3 1393.6 1346.29 1374.46 1338.94 1358.86",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.79 908.234C1269.32 918.875 1284.27 933.954 1307.78 955.199C1376.09 1017.24 1427.77 1013.48 1501.61 1113.13C1575.45 1212.77 1575.45 1289.86 1571.76 1351.9C1568.06 1413.95 1530.52 1462.83 1485 1460.95C1444.39 1459.26 1418.54 1418.35 1418.54 1418.35",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.33 1662.76C1183.33 1662.76 1217.19 1667.12 1235.65 1665.24C1243.88 1664.42 1251.86 1665.24 1259.72 1661.48L1260.57 1661.07C1270.02 1656.14 1279.29 1644.26 1288.55 1614.56C1298.45 1582.97 1285.53 1567.48 1277.48 1561.16",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.8 1699.72C1123.02 1713.24 1142.99 1722.65 1164.24 1727.29C1199.32 1734.81 1222.1 1723.53 1244.25 1689.05C1266.4 1654.56 1259.64 1661.48 1259.64 1661.48",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M888.461 1666.48C892.153 1677.77 899.094 1690.96 913.234 1695.96C921.018 1698.41 929.217 1699.16 937.305 1698.18C952.583 1696.33 967.511 1692.2 981.608 1685.93",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M959.977 1605.72C972.898 1608.84 1001.22 1598.84 1039.35 1577.51C1059.86 1566.37 1079.6 1553.8 1098.42 1539.91C1108.02 1546.69 1115.33 1556.31 1119.36 1567.47C1124.27 1583.16 1122.42 1594.44 1103.96 1607.6C1095.32 1614.03 1086.28 1619.9 1076.9 1625.16",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.03 1598.2C1119.09 1614.37 1119.94 1631.21 1117.5 1647.72C1113.81 1677.8 1118.72 1707.89 1053.52 1734.21C988.324 1760.53 959.38 1739.21 952.587 1730.45C947.307 1723.6 940.182 1705.74 937.302 1698.18",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.94 353.567C1327.94 353.567 1334.1 408.09 1313.17 475.774C1296.3 530.41 1271.93 560.379 1271.93 560.379",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.55 628.063C1360.55 628.063 1356.49 646.112 1322.41 693.867C1292.88 735.229 1276.89 748.39 1276.89 748.39",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M489.879 748.388C512.658 773.469 562.499 826.112 609.238 838.633",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.58 1021.6C1077.67 1049.17 1016.13 1229.66 939.815 1367.55C863.504 1505.43 816.764 1550.56 816.764 1550.56",
    stroke: "#B575FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11251_2601",
    x: 584.071,
    y: 32.4526,
    width: 1415.93,
    height: 1444.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_11251_2601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11251_2601",
    x: 0,
    y: 0,
    width: 1415.93,
    height: 1444.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_11251_2601"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeRmeq);
export default __webpack_public_path__ + "static/media/welcome_rmeq.08e06f70c3736b19f70ae037757463f6.svg";
export { ForwardRef as ReactComponent };